import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../reducers/authSlice";
import testReducer from "../reducers/testSlice";
// import rootReducer from "../reducers/rootReducer";

const store = configureStore({
  reducer: {
    auth: authReducer,
    test: testReducer,
  },
});

export default store;
